import { CSSProperties } from "react";
import BoxWrap1Props from "../BoxWrap1Props.interface";

export default (boxWrap: BoxWrap1Props, styles: any): any => {
    const style: CSSProperties = {};
    const classes: string[] = [];

    if (boxWrap?.content?.backgroundColor) {
        classes.push(styles.has_box_wrap);
    }

    if (boxWrap?.content?.backgroundColor) {
        style["--box-wrap-background-color"] = boxWrap.content.backgroundColor;
    }

    if (boxWrap?.content?.backgroundOpacity) {
        style["--box-wrap-background-opacity"] = boxWrap.content.backgroundOpacity;
    }

    if (boxWrap?.content?.spacing) {
        classes.push(styles[`spacing_${boxWrap.content.spacing}`]);
    }

    if (boxWrap?.content?.showShadow) {
        classes.push(styles.show_shadow);
    }

    return {
        containerStyles: style,
        containerClasses: classes.join(" ")
    };
};